import { PageHeader } from "@/components/app/PageHeader";
import { ApkReleasesPanel } from "@/components/app/ApkReleasesPanel";

export default function ApkAdminPage() {
  return (
    <div>
      <PageHeader eyebrow="Super admin" title="Fichiers APK" description="Téléversez les versions de l'application TV. La version publiée la plus récente est envoyée aux télés et proposée au téléchargement sur la page d'accueil." />
      <ApkReleasesPanel />
    </div>
  );
}
